import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { THEME } from '../../constants';
import { changeTheme } from '../../redux/global/globalReducer';

function ThemeProvider({ children }) {
  const dispatch = useDispatch();

  const theme = useSelector((state) => state.global.theme);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme || THEME.DARK);
  }, [theme]);

  useEffect(() => {
    if (!theme) {
      const localStorageTheme = localStorage.getItem('THEME');
      if (localStorageTheme) {
        dispatch(changeTheme(localStorageTheme));
        return;
      }

      const isPrefersLightTheme = window.matchMedia('(prefers-color-scheme: light)').matches;
      const initialTheme = isPrefersLightTheme ? THEME.LIGHT : THEME.DARK;

      dispatch(changeTheme(initialTheme));
      localStorage.setItem('THEME', initialTheme);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme]);

  return <>{theme ? children : null}</>;
}

export default memo(ThemeProvider);
